/**
 * CategoriesOkNote Component
 *
 * A small positive note shown beneath a routine surveillance scatter plot when
 * the plotted rows are uniform across the category columns AND every shared
 * value is a typical/default value — i.e. neither the "Category differences"
 * warning nor the "Atypical categories" note applies.
 *
 * Renders a green tick + "Categories uniform and typical". Callers render this
 * only in that all-clear case (it takes no data and always renders).
 */

import { CircleCheck } from "lucide-react"

/**
 * All-clear note indicating a plot's category columns are uniform and typical.
 *
 * @returns The green tick + confirmation text.
 */
export default function CategoriesOkNote(): React.JSX.Element {
  return (
    <span className="inline-flex items-center gap-1 text-xs text-green-600 dark:text-green-500">
      <CircleCheck className="size-3.5 shrink-0" aria-hidden="true" />
      Categories uniform and typical
    </span>
  )
}
